import { createReducer } from '@reduxjs/toolkit'
import { IStateTrailerNotes } from './TReducer'
import { Actions_TrailerNotes } from './Actions'

const initialState: IStateTrailerNotes = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerTrailerNotes = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_TrailerNotes.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_TrailerNotes.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_TrailerNotes.store.saveTrailerNotes, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_TrailerNotes.store.reset, () => {
      return initialState
    })
})

export default ReducerTrailerNotes
